import React from "react";

export const Overline = ({ children, className = "", color = "accent" }) => {
  const tone =
    color === "accent" ? "text-elle-red" : color === "cream" ? "text-elle-cream/80" : "text-elle-green";
  return (
    <div
      className={`font-body text-[11px] tracking-overline uppercase ${tone} ${className}`}
    >
      {children}
    </div>
  );
};

export default Overline;
